import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// TOPページMV専用
export function indexMvTextAnimation() {
  if (document.querySelector('.js-indexMvText01')) {
    window.addEventListener('load', () => {
      const tl = gsap.timeline();

      // 1. 右斜め上から現れつつぼかし解除＆フェードイン
      tl.fromTo(
        '.js-indexMvText01 span',
        {
          opacity: 0,
          filter: 'blur(8px)',
          x: 20,
          y: -10,
        },
        {
          opacity: 1,
          filter: 'blur(0px)',
          x: 0,
          y: 0,
          duration: 0.8,
          stagger: 0.08,
          ease: 'power2.out',
          scrollTrigger: {
            trigger: '.js-indexMvText01',
            start: 'top 80%',
            once: true,
          },
        }
      );

      // 2. 続けて左からゆったりフェードイン
      tl.fromTo(
        '.js-indexMvText02 span',
        {
          opacity: 0, // 再び透明から
          x: -40, // 左から
          filter: 'blur(8px)',
        },
        {
          opacity: 1,
          filter: 'blur(0px)',
          x: 0,
          duration: 1.2,
          stagger: 0.08,
          ease: 'power2.out',
        },
        '+=0.2' // 前のアニメーション終了後0.2秒待ってから
      );
    });
  }
}
